import React, { memo } from 'react';
import ContentLoader from 'react-content-loader';

const HomePageCardSkeleton = () => (
  <ContentLoader
    speed={1.4}
    backgroundColor="var(--neutral-200)"
    foregroundColor="var(--neutral-400)"
    className="w-full min-w-[290px] max-w-[350px] h-[338px] sm:h-[368px] mx-auto shadow-sm rounded-lg border"
  >
    <rect x="0" y="0" rx="0" ry="0" width="100%" height="428" />
  </ContentLoader>
);

export default memo(HomePageCardSkeleton);
